import React, { useState, useEffect } from "react";
import { IoMdFunnel } from "react-icons/io";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import "../../assets/css/ServicesFilter.scss";
import ListItemText from "@mui/material/ListItemText";
import { HiMiniXMark } from "react-icons/hi2";
import { Checkbox } from "@mui/material";
import useTitanApp from "../../hooks/useTitanApp";
import { setKanbanFilters } from "../../dispatchers/clinicalChecksDispatchers";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { motion } from "framer-motion";

function ChecksFilter({ filterTagsData, clearTagsFilter }) {
  const { clincicalChecksState, pharmacyServiceState } = useTitanApp();
  const { filterNmsValue } = pharmacyServiceState || {};
  const { checksTagsfilters, kanbanFilters, patientTagsColor } =
    clincicalChecksState || {};
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [openFilters, setOpenFilters] = useState(false);
  const [tagConsentedDropdown, setTagConsentedDropdown] = useState("Tag");
  const [filterNMSValueDropdown, setFilterNMSValueDropdown] =
    useState(filterNmsValue);
  const [filterTagValuesCheck, setFilterTagValuesCheck] = useState([]);
  const [filterTagConsentOpen, setFilterTagConsentOpen] = useState(false);

  useEffect(() => {
    const nextFilterValue = kanbanFilters?.filterNMSValueDropdown ?? "Is";
    const nextTagValues = kanbanFilters?.filterTagValuesCheck ?? [];
    setFilterNMSValueDropdown(nextFilterValue);
    setFilterTagValuesCheck(nextTagValues);
    filterTagsData(nextTagValues, nextFilterValue);
  }, [kanbanFilters]);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event || {};
    setFilterTagValuesCheck(
      typeof value === "string" ? value.split(",") : value
    );
  };

  function getChipColor(nameOfChip) {
    const tag = patientTagsColor.find((tag) => tag?.tagName === nameOfChip);
    return tag ? tag?.tagColour : null;
  }
  function handleSearchtag() {
    filterTagsData(filterTagValuesCheck, filterNMSValueDropdown);
    setKanbanFilters({
      filterNMSValueDropdown,
      filterTagValuesCheck,
    });
    setOpenFilters(false);
  }
  const handleButtonClick = () => {
    setOpenFilters(!openFilters);
  };
  const handleClearSearch = () => {
    setFilterTagValuesCheck([]);
    setOpenFilters(false);
    clearTagsFilter();
  };
  const handleClose = () => {
    setFilterTagConsentOpen(false);
  };

  const handleOpen = () => {
    setFilterTagConsentOpen(true);
  };
  return (
    <div className="filter_button_container">
      <button onClick={handleButtonClick} className="kanban-control-btn">
        <IoMdFunnel className="icons-color" size={14} />
        <p>Filters</p>
      </button>

      {openFilters && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0 }}
          className="search-filters"
        >
          <div className="search-filters-wrapper">
            <div className="filter_heading">
              <HiMiniXMark
                className="x-mark icons-color"
                size={16}
                onClick={() => setOpenFilters(false)}
              />
            </div>

            <div className="filters_fields">
              <FormControl size="small" sx={{ m: 0.5, width: 300 }}>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={tagConsentedDropdown}
                  onChange={(e) => setTagConsentedDropdown(e?.target?.value)}
                  className="role-select"
                  disabled={false}
                >
                  <MenuItem value="Tag">
                    <span>Tag</span>
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ m: 0.5, width: 250 }}>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={filterNMSValueDropdown}
                  onChange={(e) => setFilterNMSValueDropdown(e?.target?.value)}
                  className="role-select"
                >
                  <MenuItem value="Is">
                    <span>Is</span>
                  </MenuItem>
                  {tagConsentedDropdown === "Tag" ? (
                    <MenuItem value="IsNot">
                      <span>Is Not</span>
                    </MenuItem>
                  ) : null}
                </Select>
              </FormControl>

              {tagConsentedDropdown === "Tag" ? (
                <FormControl fullWidth size="small">
                  <Select
                    className="filter-select"
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={filterTagValuesCheck}
                    onChange={handleChange}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected?.map((value) => {
                          return (
                            <Chip
                              key={value}
                              label={value}
                              style={{ backgroundColor: getChipColor(value) }}
                            />
                          );
                        })}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    open={filterTagConsentOpen}
                  >
                    {checksTagsfilters?.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={filterTagValuesCheck.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <></>
              )}
            </div>
            <div className="filter_actions">
              <button onClick={handleClearSearch} className="filter_action">
                Clear
              </button>
              <button onClick={handleSearchtag} className="filter_action">
                Apply
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );
}

export default ChecksFilter;
